import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import { Redirect } from 'react-router';
import { CircularProgress } from '@material-ui/core';
import _ from 'lodash';
import DoctorForm from './components/DoctorForm';
import injectSaga from '../../../utils/injectSaga';
import saga from './saga';
import { saveDoctor } from '../../../redux/actions/matricularActions';

class Doctor extends PureComponent {
  handleSumbit = (values) => {
    const {
      dispatch, nucleoId, app, onCancel,
    } = this.props;

    const newDoctor = _.cloneDeep(values);
    newDoctor.nucleo = nucleoId;

    const isNew = newDoctor.medicoCabecera.value === 'new';
    let doctorId = null;
    if (!isNew) {
      doctorId = newDoctor.medicoCabecera.value;
    }
    delete newDoctor.id;
    delete newDoctor.medicoCabecera;
    dispatch(saveDoctor({
      token: app.session.id,
      isNew,
      itemId: doctorId,
      doctor: newDoctor,
    }));
    onCancel();
  }

  render() {
    const {
      app,
      onCancel,
      nucleoMedicos,
      itemId,
    } = this.props;

    return (
      <div className="modal-form">
        { app.loading && <CircularProgress className="circular-progress" /> }
        <div className="modal-form__wrapper">
          <div className="modal-form__card">
            <DoctorForm
              itemId={itemId}
              nucleoMedicos={nucleoMedicos}
              onSubmit={this.handleSumbit}
              onCancel={onCancel}
            />
          </div>
        </div>
      </div>
    );
  }
}

Doctor.propTypes = {
  dispatch: PropTypes.func.isRequired,
  app: PropTypes.shape({}).isRequired,
  onCancel: PropTypes.func.isRequired,
  nucleoId: PropTypes.string.isRequired,
  nucleoMedicos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  itemId: PropTypes.string,
};

Doctor.defaultProps = {
  itemId: '',
};

const withSaga = injectSaga({ key: 'doctor', saga });

const mapStateToProps = state => ({
  app: state.app,
});

export default withSaga(connect(mapStateToProps)(Doctor));
